var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInfoMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 0C7.05755 0 4.21875 2.8388 4.21875 6.32812C4.21875 9.81745 7.05755 12.6562 10.5469 12.6562C14.0362 12.6562 16.875 9.81745 16.875 6.32812C16.875 2.8388 14.0362 0 10.5469 0ZM10.5469 11.25C7.83295 11.25 5.625 9.04205 5.625 6.32812C5.625 3.6142 7.83295 1.40625 10.5469 1.40625C13.2608 1.40625 15.4688 3.6142 15.4688 6.32812C15.4688 9.04205 13.2608 11.25 10.5469 11.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4203 16.7904C16.6878 15.0313 14.391 14.0625 11.9531 14.0625H9.14062C6.70275 14.0625 4.40597 15.0313 2.67347 16.7904C0.949453 18.5409 0 20.8515 0 23.2969C0 23.6852 0.314812 24 0.703125 24H20.3906C20.7789 24 21.0938 23.6852 21.0938 23.2969C21.0938 20.8515 20.1443 18.5409 18.4203 16.7904ZM1.43719 22.5938C1.78945 18.6053 5.10989 15.4688 9.14062 15.4688H11.9531C15.9839 15.4688 19.3043 18.6053 19.6566 22.5938H1.43719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfoMenuIcon);
export default __webpack_public_path__ + "static/media/user_info_menu_icon.068382e713d232bb8a807c8a796bd539.svg";
export { ForwardRef as ReactComponent };